import React, { useState, useEffect } from "react";
import { HiArrowUp } from "react-icons/hi";

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollUp = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollUp}
      style={{
        position: "fixed",
        right: "28px",
        bottom: "28px",
        width: "44px",
        height: "44px",
        borderRadius: "10px",
        border: "1px solid rgba(99, 179, 237, 0.25)",
        background: "rgba(10, 15, 30, 0.9)",
        backdropFilter: "blur(12px)",
        color: "#63b3ed",
        fontSize: "18px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 999,
        transition: "all 0.25s ease",
        boxShadow: "0 4px 16px rgba(0,0,0,0.4)",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "rgba(99, 179, 237, 0.15)";
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "rgba(10, 15, 30, 0.9)";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      <HiArrowUp />
    </button>
  );
};

export default BackToTop;
